import { hasRule, rules as rules, espaceGestionRules as rulesGestion } from "@/utils/rulesHelper"

function buildMenu() {
  let children = []
  // children.push({ name: 'Choix des Espaces', url: '/', icon: 'fa fa-th' })

  if (hasRule(rules.ACCESS_ADMIN_GLOBAL)) {

    children.push({ name: 'Accueil', url: '/espaces', icon: 'icon-home' })
    if (hasRule(rules.ACCESS_ADMIN_USERS)) {
      children.push({ name: 'Gestion utilisateurs', url: '/administration/users', icon: 'icon-people' })
    }

    if (hasRule(rules.ACCESS_ADMIN_PROFILES) || hasRule(rules.ACCESS_ADMIN_DROITS) || hasRule(rules.ACCESS_ADMIN_ESPACES) || hasRule(rules.ACCESS_ADMIN_MODULES)) {
      let subChildren = []

      if (hasRule(rules.ACCESS_ADMIN_PROFILES)) {
        subChildren.push({ name: 'Gestion profils', url: '/administration/profiles', icon: 'fa fa-id-badge' })
      }
      if (hasRule(rules.ACCESS_ADMIN_DROITS)) {
        subChildren.push({ name: 'Gestion droits', url: '/administration/rules', icon: 'icon-lock-open' })
      }
      if (hasRule(rules.ACCESS_ADMIN_ESPACES)) {
        subChildren.push({ name: 'Gestion espaces', url: '/administration/espaces', icon: 'fa fa-cog' });
      }
      if (hasRule(rules.ACCESS_ADMIN_MODULES)) {
        subChildren.push({ name: 'Gestion modules', url: '/administration/modules', icon: 'fa fa-cog' });
      }

      // subChildren.push({ name: 'Table Statut PrestIJ', url: '/administration/parametrage/prestij', icon: 'fa fa-cog' })
      // subChildren.push({ name: 'Table Segment Com.', url: '/administration/parametrage/segment_commerciale', icon: 'fa fa-cog' })
      // subChildren.push({ name: 'Table Délégation Com.', url: '/administration/parametrage/delegation', icon: 'fa fa-cog' })
      children.push({ name: 'Droits/Profils', url: '/administration/profiles', icon: 'icon-lock-open', children: subChildren })
    }

    if (hasRule(rules.ACCESS_ADMIN_STATUS)) {
      children.push({ name: 'Gestion statuts', url: '/administration/statuts', icon: 'icon-check' })
    }
    if (hasRule(rules.ACCESS_ADMIN_BAL)) {
      children.push({ name: 'Gestion des BAL', url: '/administration/bal', icon: 'icon-envelope' })
    }
    if (hasRule(rules.MANAGE_TRAITEMENT)) {
      children.push({ name: 'Gestion traitements', url: '/administration/traitements', icon: 'fa fa-superpowers' })
    }
    if (hasRule(rulesGestion.CAN_CONFIGURE_DOSSIER)) {
      let subChildren = []

      subChildren.push({ name: 'Gestion des canaux', url: '/espace-gestion/parametrage/canal', icon: 'fa fa-cog' })
      subChildren.push({ name: 'Gestion des types', url: '/espace-gestion/parametrage/type', icon: 'fa fa-cog' })
      subChildren.push({ name: 'Gestion des segments', url: '/espace-gestion/parametrage/segment', icon: 'fa fa-cog' })
      subChildren.push({ name: 'Types de PJ', url: '/espace-gestion/parametrage/type-pj', icon: 'fa fa-cog' })
      children.push({ name: 'Paramétrage Dossier', url: '/espace-gestion/parametrage', icon: 'fa fa-cogs', children: subChildren })
    }
    if (hasRule(rules.CAN_ACCESS_ADMIN_REPORTS)) {
      children.push({ name: 'Gestion des rapports', url: '/administration/rapports', icon: 'fa fa-list-ol' })
    }


    if (hasRule(rules.ACCESS_PARAMETRAGE_TABLE)) {
      let subChildren = []

      if (hasRule(rules.MANAGE_TABLE_STATUT_PRESTIJ)) {
        subChildren.push({ name: 'Statut PrestIJ', url: '/administration/parametrage/prestij', icon: 'fa fa-cog' })
      }
      if (hasRule(rules.MANAGE_TABLE_SEGMENT_COMMERCIAL)) {
        subChildren.push({ name: 'Segment Com.', url: '/administration/parametrage/segmentCommercial', icon: 'fa fa-cog' })
      }
      if (hasRule(rules.MANAGE_TABLE_DELEGATION)) {
        subChildren.push({ name: 'Délégation Com.', url: '/administration/parametrage/delegation', icon: 'fa fa-cog' })
        subChildren.push({ name: 'Délég. Territoriale', url: '/administration/parametrage/delegationTerritoriale', icon: 'fa fa-cog' })
      }
      if (hasRule(rules.MANAGE_TABLE_CODE_POSTAL)) {
        subChildren.push({ name: 'Code Postal', url: '/administration/parametrage/codePostal', icon: 'fa fa-cog' })
      }

      children.push({ name: 'Paramétrage Table', url: '/administration/parametrage', icon: 'fa fa-cogs', children: subChildren })
    }
    if (hasRule(rules.ACCESS_ADMIN_FIL_OPERATIONS)) {
        children.push({ name: 'Fil des opérations', url: '/administration/operations', icon: 'fa fa-history' })
    }
    if (hasRule(rules.ACCESS_STRUCTURES)) {
        children.push({ name: 'Gestion structures', url: '/administration/structures', icon: 'fa fa-align-center' })
    }
    if (hasRule(rules.ACCESS_ADMIN_MONITORING)) {
      let subChildren = [];
      subChildren.push({ name: 'Tâches planifiées', url: '/administration/monitoring/list-cron', icon: 'fa fa-cog' })
      subChildren.push({ name: 'Utilisateurs', url: '/administration/monitoring/list-users', icon: 'icon-people' })

      children.push({ name: 'Monitoring', url: '/administration/monitoring', icon: 'cui-dashboard', children: subChildren })
    }
    if (hasRule(rules.ACCESS_ASTUCES)) {
      children.push({ name: 'Gestion Astuces', url: '/administration/astuces', icon: 'fa fa-list-ol' })
    }

    if (hasRule(rules.MANAGE_OAP_OAG)) {
      children.push({ name: 'Gestion OAG', url: '/administration/gestionOapOag/oag', icon: 'fa fa-cogs'})
      children.push({ name: 'Gestion OAP', url: '/administration/gestionOapOag/oap', icon: 'fa fa-cogs'})
    }

    if (hasRule(rules.CAN_ACCESS_LIVRAISONS)) {
      children.push({ name: 'Gestion livraisons', url: '/administration/livraisons', icon: 'fa fa-cogs' })
    }
    if (hasRule(rules.CAN_ACCESS_HISTO_LIVRAISONS)) {
      children.push({ name: 'Histo livraisons', url: '/last-versions/list', icon: 'fa fa-history' })
    }
    if (hasRule(rules.CAN_ACCESS_UPLOAD_FILE_INTERFACE)) { 
      children.push({ name: 'Gestion Fichiers', url: '/administration/gestionFichiers', icon: 'fa fa-folder-open' })
    }

  }

  return children
}

let menu = {
  items: buildMenu()
}
export default menu
